module.exports = __webpack_public_path__ + "static/media/belarus-small.7ea36157.jpg";